export default __webpack_public_path__ + "static/media/image.eb6b96b7.jpeg";